import { createFileRoute } from "@tanstack/react-router";
import { ParentPinReset } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/parent/pin-reset")({
  head: () => seoHead({ title: "Reset Parent PIN", noindex: true }),
  component: ParentPinReset,
});
